export enum OfferingRelationshipType {
  PARENT_OF = 'Parent of',
  CHILD_OF = 'Child of',
}
